import React, { useState, useMemo, useCallback, useEffect } from "react";

import Calculate from "components/payments/Calculator";
import Formmoneypay from "components/payments/Inputmoneypay";

const STEPS = {
  SELECT_BANK: 1,
  ADD_AMOUNT: 2,
};

export default function PayTranfer({
  payment,
  money,
  actions,
  order,
  ui,
  provider,
  settings,
  ...props
}) {
  const { amount, setAmount } = money;
  const { addPayment, handleCompletePayment } = actions;
  const { details } = order;
  const { buttons } = ui;
  const { setData: setProviderData } = provider;
  const { paymentSettings } = settings;

  const [step, setStep] = useState(STEPS.SELECT_BANK);
  const [bankSelect, setBankSelect] = useState(null);

  const bankList = useMemo(() => {
    return Array.isArray(paymentSettings?.bank) ? paymentSettings.bank : [];
  }, [paymentSettings]);

  const handleBankConfirmation = () => {
    if (!bankSelect) return;

    setProviderData(bankSelect);
    setStep(STEPS.ADD_AMOUNT);
  };

  const isPaymentSuccess =
    parseFloat(details.paymentTotal) >= parseFloat(details.paymentNet);

  const isZeroAmount = useMemo(() => {
    if (!amount || amount === "" || amount === "0" || amount === "0.00") {
      return true;
    }
    const numAmount = parseFloat(amount);
    return numAmount === 0 || isNaN(numAmount);
  }, [amount]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" && step === STEPS.ADD_AMOUNT) {
        if (isZeroAmount || isPaymentSuccess) {
          e.preventDefault();
        } else {
          e.preventDefault();
          addPayment();
        }
      }
    },
    [step, isZeroAmount, isPaymentSuccess, addPayment]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div className="d-flex flex-column h-100">
      {step === STEPS.ADD_AMOUNT && bankSelect ? (
        <>
          <div className="d-flex align-items-center text-[#061126] mb-1">
            <div className="me-auto">
              <span className="fs-18 fw-500">Order NO.</span>
              <span className="fs-14 fw-500 ms-2">
                {details?.orderNo || ""}
              </span>
            </div>
            <div className="fs-18 fw-bold text-[#2DC76D]">โอนเงิน</div>
          </div>

          <div className="fs-14 fw-500 mb-3">กรุณาระบุยอดเงินรับชำระ</div>

          <div className="py-2">
            <Formmoneypay moneypay={amount} setMoneypay={setAmount} />
          </div>

          <Calculate
            setMoneypay={setAmount}
            moneypay={amount}
            PaymentDetail={details}
          />

          <div className="d-flex align-items-center pt-2">
            <button
              className="me-auto btn btn-st-q1 px-5"
              onClick={addPayment}
              disabled={isPaymentSuccess || isZeroAmount}
            >
              Enter
            </button>
            <button
              className="btn btn-st-q1"
              onClick={handleCompletePayment}
              disabled={buttons.paymentDisabled}
            >
              ชำระเงิน
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="fs-18 fw-500 text-[#061126] mb-4">
            กรุณาเลือกธนาคารรับเงิน
          </div>

          <div
            className="bx-paylist p-3 overflow-auto mb-auto"
            style={{
              background: "#FFF",
              filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.14))",
              borderRadius: "8px",
              height: "calc(100vh - 500px)",
            }}
          >
            <div className="row gx-3">
              {Array.isArray(bankList) &&
                bankList.map((item) => (
                  <div className="col-6" key={item.id}>
                    <div
                      className={`d-flex align-items-center card-bank ${
                        bankSelect && item.id === bankSelect.id ? "active" : ""
                      } mb-3`}
                      style={{ cursor: "pointer" }}
                      onClick={() => setBankSelect(item)}
                    >
                      <img
                        src={item.logo}
                        style={{
                          width: "32px",
                          height: "32px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                        alt={`${item.name} logo`}
                      />
                      <div className="text-[#061126] fs-14 ms-3">
                        {item.name}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end pt-2">
            <button
              className="btn btn-st-q1 px-5"
              onClick={handleBankConfirmation}
              disabled={!bankSelect}
            >
              ยืนยัน
            </button>
          </div>
        </>
      )}
    </div>
  );
}
